// extracted by mini-css-extract-plugin
export default {"Container":"SwitchButtons_Container__u0e1o","Switch":"SwitchButtons_Switch__YkJyo","SwitchActive":"SwitchButtons_SwitchActive__QT-SH"};